import PermissionStatus from "../enum/PermissionStatus";
import DeviceStatuses from "../types/DeviceStatuses";

// A rolled-up row has one honest answer only when every device agrees; otherwise expand to see.
const rollupField = <T>(values: T[], mixed: T): T =>
  values.every((value) => value === values[0]) ? values[0] : mixed;

const rollupStatuses = (statuses: DeviceStatuses[]): DeviceStatuses => ({
  backgroundRefresh: rollupField(
    statuses.map(({ backgroundRefresh }) => backgroundRefresh),
    PermissionStatus.MIXED
  ),
  location: rollupField(
    statuses.map(({ location }) => location),
    PermissionStatus.MIXED
  ),
  motion: rollupField(
    statuses.map(({ motion }) => motion),
    PermissionStatus.MIXED
  ),
  notifications: rollupField(
    statuses.map(({ notifications }) => notifications),
    PermissionStatus.MIXED
  ),
  preciseLocation: rollupField(
    statuses.map(({ preciseLocation }) => preciseLocation),
    PermissionStatus.MIXED
  ),
});

export default rollupStatuses;
